module.exports = __webpack_public_path__ + "img/03.10fa760c.png";